module.exports = __webpack_public_path__ + "static/media/main.f3badac1.png";